import { Button } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import StormBuildUpTable, { StormBuildUpTableProps } from "./StormBuildUpTable";
import { getSwalesRows, MAX_SWALE_SECTIONS } from "../../../utils/stormBuildUpSwales";
import { COLORS } from "../../../utils/constants";

type SwalesTableProps = Omit<StormBuildUpTableProps, 'rows' | 'onDeleteSection' | 'onConfigureSection'> & {
  sectionCount: number;
  onAddSwale: () => void;
  onDeleteSection: (headerId: string) => void;
  onConfigureSection: (headerId: string) => void;
  exTopsoilMm?: number;
  swaleTopsoilThicknessMm?: Record<string, number>;
  sectionTitles?: Record<string, string>;
};

export default function SwalesTable({ sectionCount, onAddSwale, onDeleteSection, onConfigureSection, exTopsoilMm, swaleTopsoilThicknessMm, sectionTitles, ...props }: SwalesTableProps) {
  return (
    <div>
      <StormBuildUpTable
        rows={getSwalesRows(sectionCount, exTopsoilMm, swaleTopsoilThicknessMm, sectionTitles)}
        onDeleteSection={onDeleteSection}
        onConfigureSection={onConfigureSection}
        {...props}
      />
      <div style={{ marginTop: '16px' }}>
        <Button
          type="text"
          icon={<PlusOutlined style={{ color: COLORS.primary }} />}
          onClick={onAddSwale}
          disabled={sectionCount >= MAX_SWALE_SECTIONS}
          style={{ color: COLORS.primary, fontWeight: 500, padding: '4px 8px' }}
        >
          Add New Swale
        </Button>
      </div>
    </div>
  );
}
